import { FC } from 'react';
import RemoveIcon from '@mui/icons-material/Remove';
import { Divider, IconButton, InputAdornment, TextField, Tooltip, Typography } from '@mui/material';
import { UploadButton } from './UploadButton';
import { EditableLabel, INomenclatureField } from '../assets/addedit-forms/EditableLabel';
import { InputFieldConditionalRendering } from '../conditional-rendering/InputFieldConditionalRendering';

interface UploadPropertyDocumentsProps {
  headline: string;
  document?: string;
  showDivider?: boolean;
  fileUrl: string;
  setFileUrl: (fileUrl: string) => void;
  disabled?: boolean;
  tooltipContent?: string | undefined;
  nomenclatureField?: INomenclatureField;
  fieldName?: string;
}

export const UploadPropertyDocuments: FC<UploadPropertyDocumentsProps> = ({
  headline,
  showDivider,
  fileUrl,
  disabled,
  setFileUrl,
  tooltipContent,
  nomenclatureField,
  fieldName,
}) => {
  return (
    <InputFieldConditionalRendering fieldName={fieldName}>
      <>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 0' }}>
          {nomenclatureField ? (
            <EditableLabel nomenclatureField={nomenclatureField} fallbackTranslationKey={headline} />
          ) : (
            <Typography variant="button">{headline}</Typography>
          )}
          <UploadButton disabled={disabled} fileUrl={fileUrl} setFileUrl={setFileUrl} tooltipContent={tooltipContent} />
        </div>
        {showDivider && <Divider />}
      </>
    </InputFieldConditionalRendering>
  );
};

interface UploadPropertyOtherDocumentsProps {
  name: string;
  fileUrl: string;
  disabled?: boolean;
  label: string;
  setName: (name: string) => void;
  setFileUrl: (fileUrl: string) => void;
  removeOtherDocument: () => void;
  tooltipContent?: string | undefined;
}

export const UploadPropertyOtherDocuments: FC<UploadPropertyOtherDocumentsProps> = ({
  name,
  fileUrl,
  disabled,
  label,
  setName,
  setFileUrl,
  removeOtherDocument,
  tooltipContent,
}) => {
  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 0' }}>
        <TextField
          disabled={disabled}
          label={label}
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Tooltip title={disabled && tooltipContent ? tooltipContent : null}>
                  <span>
                    <IconButton onClick={removeOtherDocument} edge="end" disabled={disabled}>
                      {<RemoveIcon />}
                    </IconButton>
                  </span>
                </Tooltip>
              </InputAdornment>
            ),
          }}
        />
        <UploadButton disabled={disabled} fileUrl={fileUrl} setFileUrl={setFileUrl} tooltipContent={tooltipContent} />
      </div>
      <Divider />
    </>
  );
};
